// ============================================================================
// GROUP IMAGE HELPERS
// Groups show an APN logo by default until the creator picks a different logo
// or uploads a custom photo. A group's stored `image` can be:
//   - '' / missing        → fall back to the default APN logo
//   - '/apn-logos/x.png'  → a bundled logo (relative to PUBLIC_URL)
//   - 'https://…'         → an uploaded photo (Firebase Storage URL, used as-is)
// ============================================================================

// Square APN marks work best as group avatars. Files live in public/apn-logos/.
export const APN_GROUP_LOGOS = [
  { label: 'APN Blue', path: '/apn-logos/APN-Tag-SQ-blue.png' },
  { label: 'APN Black', path: '/apn-logos/APN-Tag-SQ-black.png' },
  { label: 'APN Clear', path: '/apn-logos/APN-Tag-SQ-trans.png' },
  { label: 'APN Stacked', path: '/apn-logos/APN-Tag-Stack-blue.jpg' },
];

export const DEFAULT_GROUP_IMAGE = '/apn-logos/APN-Tag-SQ-blue.png';

// Resolve a group's stored image to a renderable src.
export const resolveGroupImage = (image) => {
  const pub = process.env.PUBLIC_URL || '';
  if (!image) return `${pub}${DEFAULT_GROUP_IMAGE}`;
  if (/^https?:\/\//i.test(image)) return image; // uploaded photo
  return `${pub}${image}`; // bundled logo (relative path)
};
